import { getBasicTokenInfo } from '@/hooks/pricing/useBasicTokenInfo';
import { transformAddress } from '../asset/nativeAddressHelper';
export default async function getFromAssetPrices({
  fromAssets
}) {
  return await Promise.all((fromAssets || []).map(async asset => {
    var _a, _b, _c, _d, _e, _f;
    const {
      address: tAddres
    } = transformAddress(asset.contract_address, asset.network);
    const result = await getBasicTokenInfo(asset.network, tAddres);
    const amountToUsePercentage = asset.amountToUse / asset.usd_value;
    const newUsdValue = (((_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.tokenInfo) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.priceUSD) || asset.quote_rate) * asset.formatted_balance;
    const newQuoteRate = ((_f = (_e = (_d = result === null || result === void 0 ? void 0 : result.tokenInfo) === null || _d === void 0 ? void 0 : _d.results) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.priceUSD) || asset.quote_rate;
    return Object.assign(Object.assign({}, asset), {
      quote: newUsdValue,
      amountToUse: amountToUsePercentage * newUsdValue,
      quote_rate1: asset.quote_rate1 || asset.quote_rate,
      quote_rate: newQuoteRate,
      usd_value: newUsdValue
    });
  }));
}